"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _get_date = _interopRequireDefault(require("date-fns/get_date"));
var _get_month = _interopRequireDefault(require("date-fns/get_month"));
var _get_year = _interopRequireDefault(require("date-fns/get_year"));
var _traveller = require("../utils/traveller.utils");
var _constants = require("../constants");
function travellerFactory(_ref) {
  var _paxUnit$info, _paxUnit$info2, _ptc$nationalIdRequir, _ptc$passportRequired, _ptc$documentType, _traveller$additional, _traveller$additional2, _traveller$travellerI, _ptc$dobRequired, _ptc$apisRequired, _traveller$additional3, _traveller$travellerI2, _traveller$travellerI3, _traveller$travellerI4, _traveller$travellerI5, _traveller$additional4;
  var paxUnit = _ref.paxUnit,
    traveller = _ref.traveller,
    ssr = _ref.ssr,
    $currency = _ref.$currency,
    hasFrequentFlyerOptions = _ref.hasFrequentFlyerOptions,
    hasMealOptions = _ref.hasMealOptions,
    vendor = _ref.vendor;
  var convertPrice = function convertPrice(v) {
    return Number(v) ? $currency.convertPrice(v) : v;
  };
  var formatPrice = function formatPrice(v) {
    return Number(v) ? $currency.formatPriceWithDecimals(v, 2) : v;
  };
  var type = paxUnit === null || paxUnit === void 0 ? void 0 : (_paxUnit$info = paxUnit.info) === null || _paxUnit$info === void 0 ? void 0 : _paxUnit$info.type;
  var seatIndex = paxUnit === null || paxUnit === void 0 ? void 0 : (_paxUnit$info2 = paxUnit.info) === null || _paxUnit$info2 === void 0 ? void 0 : _paxUnit$info2.ref;
  var ptc = paxUnit === null || paxUnit === void 0 ? void 0 : paxUnit.ptc;
  var totals = (0, _mapValues2.default)(paxUnit === null || paxUnit === void 0 ? void 0 : paxUnit.totals, function (v) {
    return convertPrice(v);
  });
  var baseTotals = (0, _mapValues2.default)(paxUnit === null || paxUnit === void 0 ? void 0 : paxUnit.totals, function (v) {
    return formatPrice(v);
  });
  var totalWithoutLuggage = Number(totals.luggage) ? totals.total - totals.luggage : totals.total;
  totals.totalWithoutLuggage = totalWithoutLuggage;
  baseTotals.totalWithoutLuggage = formatPrice(totalWithoutLuggage);
  var displayTotals = (0, _mapValues2.default)(totals, function (v) {
    return formatPrice(v);
  });
  displayTotals.currency = $currency.currentCurrency;
  var isInfant = type === _constants.TRAVELLERS_TYPES_MAP.INFANT.code;
  var isNationalIdRequired = (_ptc$nationalIdRequir = ptc === null || ptc === void 0 ? void 0 : ptc.nationalIdRequired) !== null && _ptc$nationalIdRequir !== void 0 ? _ptc$nationalIdRequir : false;
  var isPassportRequired = (_ptc$passportRequired = ptc === null || ptc === void 0 ? void 0 : ptc.passportRequired) !== null && _ptc$passportRequired !== void 0 ? _ptc$passportRequired : false;
  var documentTypes = (_ptc$documentType = ptc === null || ptc === void 0 ? void 0 : ptc.documentType) !== null && _ptc$documentType !== void 0 ? _ptc$documentType : [];
  var getDocumentType = function getDocumentType(countryCode) {
    return (0, _traveller.getDocumentTypes)(documentTypes, countryCode);
  };
  var getIssuingCountry = function getIssuingCountry(countryList, selectedDocumentType) {
    return (0, _traveller.getIssuingCountries)(documentTypes, countryList, selectedDocumentType);
  };
  var birthDateHijri = traveller === null || traveller === void 0 ? void 0 : (_traveller$additional = traveller.additionalData) === null || _traveller$additional === void 0 ? void 0 : _traveller$additional.birthDateHijri;
  var birthDateIsHijri = !!birthDateHijri && isNationalIdRequired;
  var birthDate = String(birthDateIsHijri ? birthDateHijri : traveller === null || traveller === void 0 ? void 0 : traveller.birthDate);
  var idExpiryDateHijri = traveller === null || traveller === void 0 ? void 0 : (_traveller$additional2 = traveller.additionalData) === null || _traveller$additional2 === void 0 ? void 0 : _traveller$additional2.expiryDateHijri;
  var idExpiryDateIsHijri = !!idExpiryDateHijri && isNationalIdRequired;
  var idExpiryDate = String(idExpiryDateIsHijri ? idExpiryDateHijri : traveller === null || traveller === void 0 ? void 0 : (_traveller$travellerI = traveller.travellerId) === null || _traveller$travellerI === void 0 ? void 0 : _traveller$travellerI.expiryDate);
  return {
    id: [type, seatIndex].join('_'),
    type: type,
    seatIndex: seatIndex,
    totals: totals,
    baseTotals: baseTotals,
    displayTotals: displayTotals,
    isAdult: type === _constants.TRAVELLERS_TYPES_MAP.ADULT.code,
    isChild: type === _constants.TRAVELLERS_TYPES_MAP.CHILD.code,
    isInfant: isInfant,
    isQualifiedTraveller: !isInfant,
    hasAdvancedOptions: vendor !== _constants.VENDORS.TF && !isInfant,
    hasFrequentFlyerOptions: hasFrequentFlyerOptions && !isInfant,
    hasMealOptions: hasMealOptions && !isInfant,
    isNationalIdRequired: isNationalIdRequired,
    isPassportRequired: isPassportRequired,
    isIDRequired: isNationalIdRequired || isPassportRequired,
    isDateOfBirthRequired: (_ptc$dobRequired = ptc === null || ptc === void 0 ? void 0 : ptc.dobRequired) !== null && _ptc$dobRequired !== void 0 ? _ptc$dobRequired : false,
    isAPIsRequired: (_ptc$apisRequired = ptc === null || ptc === void 0 ? void 0 : ptc.apisRequired) !== null && _ptc$apisRequired !== void 0 ? _ptc$apisRequired : false,
    getDocumentType: getDocumentType,
    getIssuingCountry: getIssuingCountry,
    travellerId: traveller === null || traveller === void 0 ? void 0 : traveller.id,
    index: traveller === null || traveller === void 0 ? void 0 : (_traveller$additional3 = traveller.additionalData) === null || _traveller$additional3 === void 0 ? void 0 : _traveller$additional3.index,
    title: traveller === null || traveller === void 0 ? void 0 : traveller.title,
    firstName: traveller === null || traveller === void 0 ? void 0 : traveller.firstName,
    middleName: traveller === null || traveller === void 0 ? void 0 : traveller.middleName,
    lastName: traveller === null || traveller === void 0 ? void 0 : traveller.lastName,
    birthDate: new Date(birthDate),
    birthDateDay: (0, _get_date.default)(birthDate),
    birthDateMonth: (0, _get_month.default)(birthDate),
    birthDateYear: (0, _get_year.default)(birthDate),
    birthDateIsHijri: birthDateIsHijri,
    idExpiryDate: new Date(idExpiryDate),
    idExpiryDateDay: (0, _get_date.default)(idExpiryDate),
    idExpiryDateMonth: (0, _get_month.default)(idExpiryDate),
    idExpiryDateYear: (0, _get_year.default)(idExpiryDate),
    idExpiryDateIsHijri: idExpiryDateIsHijri,
    idType: (_traveller$travellerI2 = traveller === null || traveller === void 0 ? void 0 : (_traveller$travellerI3 = traveller.travellerId) === null || _traveller$travellerI3 === void 0 ? void 0 : _traveller$travellerI3.type) !== null && _traveller$travellerI2 !== void 0 ? _traveller$travellerI2 : _constants.ID_TYPES.PASSPORT,
    idNumber: traveller === null || traveller === void 0 ? void 0 : (_traveller$travellerI4 = traveller.travellerId) === null || _traveller$travellerI4 === void 0 ? void 0 : _traveller$travellerI4.number,
    issuingCountry: traveller === null || traveller === void 0 ? void 0 : (_traveller$travellerI5 = traveller.travellerId) === null || _traveller$travellerI5 === void 0 ? void 0 : _traveller$travellerI5.issueCountry,
    nationality: traveller === null || traveller === void 0 ? void 0 : traveller.nationality,
    isPrimaryContact: traveller === null || traveller === void 0 ? void 0 : (_traveller$additional4 = traveller.additionalData) === null || _traveller$additional4 === void 0 ? void 0 : _traveller$additional4.isPrimaryContact,
    ssr: ssr
  };
}
var _default = exports.default = travellerFactory;